import React, { useEffect, useState } from "react";
import ProductList from "../components/ProductList";
import CategoryList from "../components/CategoryList";
import BestSellerProducts from "../components/BestSellerProducts";
import LatestProducts from "../components/LatestProducts";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

const Homepage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [
    "https://www.butterflyassets.online/slidepic3.jpg",
    "https://www.butterflyassets.online/slidepic1.jpg",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 20000); // Change slide every 20 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  const [products, setProducts] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://supplement-app-d151447d38d4.herokuapp.com/api/products/store/677d6481488a90375af44531"
        );
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="homepage">
      <Helmet>
        <title>Mushroom Grow Kits & Magic Mushroom Spores | Spores Bro</title>
        <meta 
          name="description" 
          content="Spores Bro offers premium magic mushroom spore syringes and mushroom grow kits for research and personal use in the USA. Discover rare strains and quality products for your microscopy and cultivation needs." 
        />
      </Helmet>

      {/* Hero Section with Slider */}
      <div className="relative w-full h-80 overflow-hidden">
        <div
          className="absolute inset-0 flex transition-transform duration-1000"
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {images.map((src, index) => (
            <div
              key={index}
              className="relative w-full h-80 flex-shrink-0 bg-cover bg-center"
              style={{
                backgroundImage: `url(${src})`,
              }}
            >
              <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 text-center px-4">
                <h1 className="text-3xl md:text-5xl font-bold text-white mb-2">
                  Discover Premium Mushroom Grow Kits
                </h1>
                <p className="text-white mb-4">
                  Explore our curated collection of magic mushroom spores and grow kits,
                  designed for quality and research.
                </p>
                <button
                  className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-md hover:bg-blue-700"
                  onClick={() => navigate("/shop")}
                >
                  Shop Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Buttons */}
        <button
          className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
          onClick={() =>
            setCurrentSlide((prev) => (prev - 1 + images.length) % images.length)
          }
        >
          &#8249;
        </button>
        <button
          className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
          onClick={() => setCurrentSlide((prev) => (prev + 1) % images.length)}
        >
          &#8250;
        </button>
      </div>

      {/* Category Section */}
      <section className="py-8">
        <CategoryList />
      </section>

      {/* Product Section */}
      <section className="py-8">
        <ProductList products={products} />
      </section>

      {/* Promotional Section */}
      <section className="max-w-3xl mx-auto my-12 bg-white shadow-lg rounded-lg overflow-hidden p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          Why Choose Spores Bro?
        </h2>
        <p className="text-gray-600 mb-4">
          With over 1000 mushroom spore syringes in stock, Spores Bro delivers quality products 
          for both bulk and retail orders across the USA. We are dedicated to providing the best strains 
          and products for your research and cultivation needs.
        </p>
        <Link to="/shop">
          <button className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-md hover:bg-blue-700">
            Explore Our Collection
          </button>
        </Link>
      </section>

      {/* FAQ Section */}
      <section className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-center mb-6">
          Frequently Asked Questions
        </h2>
        <div>
          {[
            {
              question: "What are magic mushroom spores?",
              answer:
                "Magic mushroom spores are the reproductive cells of mushrooms from the Psilocybe genus. They don't contain psilocybin or psilocin until the mushrooms grow.",
            },
            {
              question: "What substrates can be used for mushroom cultivation?",
              answer:
                "Common substrates include straw, sawdust, coffee grounds, and compost. The choice depends on the mushroom species.",
            },
            {
              question: "How long does it take for mushrooms to grow?",
              answer:
                "Depending on the species and growing conditions, mushrooms can mature anywhere from a few days to several weeks after colonization.",
            },
            {
              question: "Is it legal to buy magic mushroom spores online?",
              answer:
                "Yes, in most states, purchasing magic mushroom spores for research purposes is legal. However, some states may have restrictions.",
            },
          ].map((faq, index) => (
            <div key={index} className="border border-gray-300 rounded-md mb-4">
              <button
                onClick={() => toggleAccordion(index)}
                className="flex justify-between w-full p-4 text-lg font-semibold focus:outline-none"
              >
                {faq.question}
                <span>{activeAccordion === index ? "-" : "+"}</span>
              </button>
              {activeAccordion === index && (
                <div className="p-4 text-gray-600">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Homepage;
